import { Typography } from "@mui/material";

import { ShipperSentRequests } from "components/Network/ShipperSentRequests";
import { useRoleContext } from "hooks";
import { PageLayout } from "layouts";

import { NetworkGroupManager } from "../NetworkGroupManager";

export function Network() {
  const { role } = useRoleContext();
  if (role == null) {
    return null;
  }
  return (
    <PageLayout>
      <Typography variant="h4" fontWeight="600" mb="1rem">
        My Carrier Network
      </Typography>
      <Typography variant="body1">
        Add the carriers you already work with to your network on Evotrux. It is
        always free for them to quote and book your loads.
      </Typography>
      <Typography variant="body1" mb="1rem">
        All of the carriers you add, including any who do not yet have Evotrux
        accounts, will be emailed about the loads you list them on, and will be
        able to quote them.
      </Typography>
      <ShipperSentRequests networkGroupsComponent={<NetworkGroupManager />} />
    </PageLayout>
  );
}
